// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"a08aab11","697":"659620ab","888":"7fd0dcc0"}[chunkId] + ".chunk.js";
};